import React, { useState, useEffect } from "react"
import { Box, Dialog, DialogContent, Typography, IconButton } from "@mui/material"
import styled from "@emotion/styled"
import { useTheme } from "@mui/system"
import CloseIcon from "@mui/icons-material/Close"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent",
    maxWidth: 600,
    width: "100%"
  },
  "& .MuiDialogContent-root": {
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    border: "none",
    width: "100%",
    padding: 32,
    boxSizing: "border-box"
  }
}))

const RenamePodModal = ({ open, onClose, podName, onSave }) => {
  const theme = useTheme()
  const [name, setName] = useState("")
  const [error, setError] = useState("")

  const styles = {
    closeBtn: {
      color: theme.palette.text.primary,
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: theme.palette.background.main
    }
  }

  useEffect(() => {
    if (open) {
      setName(podName || "")
      setError("")
    }
  }, [open, podName])

  const handleSave = () => {
    if (!name || name.trim() === "") {
      setError("Team name is required")
      return
    }

    if (name === podName) {
      onClose()
      return
    }

    onSave(name)
  }

  const handleChange = (e) => {
    setName(e.target.value)
    if (error) {
      setError("")
    }
  }

  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogContent>
        <Box className="d-flex justify-content-end">
          <IconButton onClick={onClose} sx={styles.closeBtn}>
            <CloseIcon sx={{ height: "14px", width: "14px" }} />
          </IconButton>
        </Box>

        <Box className="w-100 d-flex justify-content-center mb-2">
          <Typography
            variant="h2"
            sx={{ fontFamily: "Lyon-Italic", fontSize: "32px", fontWeight: 400 }}>
            Rename Team
          </Typography>
        </Box>

        <Box flexDirection="column" className="mt-4">
          <Box className="w-100 py-2">
            <AppTextField
              id="teamName"
              name="teamName"
              isUpperCase={false}
              type="text"
              fullWidth
              label="Team Name"
              isRequired={true}
              placeholder="Enter Team Name"
              value={name}
              onChange={handleChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Box>
        </Box>

        <Box className="mt-5 d-flex justify-content-center">
          <AppButton
            onClick={handleSave}
            sx={{
              height: "48px",
              padding: "10px 50px"
            }}>
            Save
          </AppButton>
        </Box>
      </DialogContent>
    </StyledDialog>
  )
}

export default RenamePodModal
